module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-7.webp?fb98aa99";